// extracted by mini-css-extract-plugin
export var label = "_dc-5";
export var slideContainer = "_dc-0";
export var slider = "_dc-1";
export var sliderLg = "_dc-4";
export var sliderMd = "_dc-3";
export var sliderSm = "_dc-2";